import { CtrlType } from "@yuigoto/ctrl";

export const ShippingAddressChangeControl = [
    {
        name: "shippingPostalCode",
        label: "CEP",
        type: CtrlType.CEP,
        required: true
    },
    {
        name: "uf",
        label: "UF",
        type: CtrlType.DROPDOWN,
        options:
            [{ "value": 12, "name": "Acre" },
            { "value": 27, "name": "Alagoas" },
            { "value": 16, "name": "Amapá" },
            { "value": 13, "name": "Amazonas" },
            { "value": 29, "name": "Bahia" },
            { "value": 23, "name": "Ceará" },
            { "value": 53, "name": "Distrito Federal" },
            { "value": 32, "name": "Espírito Santo" },
            { "value": 52, "name": "Goiás" },
            { "value": 21, "name": "Maranhão" },
            { "value": 51, "name": "Mato Grosso" },
            { "value": 50, "name": "Mato Grosso do Sul" },
            { "value": 31, "name": "Minas Gerais" },
            { "value": 15, "name": "Pará" },
            { "value": 25, "name": "Paraíba" },
            { "value": 41, "name": "Paraná" },
            { "value": 26, "name": "Pernambuco" },
            { "value": 22, "name": "Piauí" },
            { "value": 33, "name": "Rio de Janeiro" },
            { "value": 24, "name": "Rio Grande do Norte" },
            { "value": 43, "name": "Rio Grande do Sul" },
            { "value": 11, "name": "Rondônia" },
            { "value": 14, "name": "Roraima" },
            { "value": 42, "name": "Santa Catarina" },
            { "value": 35, "name": "São Paulo" },
            { "value": 28, "name": "Sergipe" },
            { "value": 17, "name": "Tocantins" }]
    },
    {
        name: "shippingCity",
        label: "Cidade",
        required: true
    },
    {
        name: "shippingStreetNeighborhood",
        label: "Bairro",
        required: true,
        value: null
    },
    {
        name: "shippingStreet",
        label: "Endereço",
        required: true
    },
    {
        name: "shippingStreetNumber",
        label: "Número",
        required: true
    },
    {
        name: "shippingStreetExtension",
        label: "Complemento"
    },
    {
        name: "shippingName",
        label: "Nome",
        required: true
    },
    {
        name: "shippingPhone",
        label: "Número",
        required: true
    }
]